import initSequentialLottie from '../parts/lottie-sequence';
const SELECTOR_SECTION = '.block-blind-section';
const init = () => initSequentialLottie(SELECTOR_SECTION, { viewportSelector: '.block-blind-section__cards' });
document.addEventListener('DOMContentLoaded', init);
if (window.acf) {
    window.acf.addAction('render_block_preview', init);
}
export default init;
